import React, { useContext } from 'react';
import { ProductContext } from '../../../../store';
import DetailSkeleton from '../../../../components/Skeleton/DetailSkeleton';
import MagentoEditLandingPage from './Magento/EditLandingPage';

const PLATFORMS = { MAGENTO: "magento", SHOPIFY: "shopify", BIGCOMMERCE: "bigcommerce", WOOCOMMERCE: "woocommerce", DRUPAL: "drupal" };

const getMerchandisingApiConfig = (platform) => {
	const base = platform === PLATFORMS.MAGENTO ? "ms2" : "ms3";
	const prefix = platform === PLATFORMS.MAGENTO ? "merchandising" : platform;
	const path = (endpoint) => `api/v1/${prefix}/${endpoint}`;
	return { base, prefix, path };
};

const EDIT_LANDING_PAGE_BY_PLATFORM = {
	[PLATFORMS.MAGENTO]: MagentoEditLandingPage,
};

const EditLandingPage = () => {
	const { currentWebsiteId, websiteData } = useContext(ProductContext);
	const platform = websiteData?.[currentWebsiteId]?.websiteType;
	const apiConfig = platform ? getMerchandisingApiConfig(platform) : null;
	const PageContent = platform ? EDIT_LANDING_PAGE_BY_PLATFORM[platform] : null;

	if (!platform || !apiConfig || !PageContent) return <DetailSkeleton />;

	return <PageContent apiConfig={apiConfig} />;
};

export default EditLandingPage;